import React, { Component } from 'react';
import { Table } from "react-bootstrap";

import { EstRetiroDir } from "../../funciones/EstudiantesFunction";

import EstRetiroTableAdmin from "./EstRetiroTableAdmin";

class RetiroEstudiantes extends Component {
    state = {
        strings: "",
        icon2: "",
        estudiantes: [],
        preload: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando Estudiantes Retirados"
        },
        cantEst: <i className="fa fa-spinner fa-spin"></i>,
    }

    componentDidMount = () => {
        this.busquedaEstudiante()
    }

    busquedaEstudiante = () => {
        EstRetiroDir((resp) => {
            let preloadIcon = "";
            let preloadText = "";

            if (resp.length === 0) {
                preloadIcon = "fa fa-times";
                preloadText = "No tienes estudiantes retirados"
            }

            let data = 0;
            resp.forEach(i => { if(i.status === "2") data++ })

            this.setState({
                estudiantes: resp,
                cantEst: data,
                preload: {
                    icon: preloadIcon,
                    text: preloadText
                }
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    busquedaEst = () => (e) => {

    }

    listRetiroEst = () => {
        let {estudiantes, preload} = this.state;

        if (estudiantes.length === 0) return (
            <tr>
                <td colSpan={3} align="center"><i className={preload.icon}></i> {preload.text}</td>
            </tr>
        )

        return (
            estudiantes.map(option => (
                <EstRetiroTableAdmin
                tipo = "Solicitud"
                key={option.id}
                data={option}
                update = {()=> {this.busquedaEstudiante()}}
                />
            ))
        )
    }
    
    render() { 
        let {strings, icon2, cantEst} = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                {/* <div className="custom-alert-info">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={strings} onChange={this.cambiaValor("strings")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div> */}
                <div className="custom-mt-10 text-danger">Retiros sin revisar ({cantEst})</div>
                <div className="custom-alert-warning" style={{padding: 5}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "40vh"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color-warning">
                                    <td width="80%" style={styles}><strong>Estudiantes</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.listRetiroEst()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
 
export default RetiroEstudiantes;


// WEBPACK FOOTER //
// ./src/views/Administracion/RetiroEstudiantes.jsx